// 261005 E4-P2 — chữ hiển thị tiến độ theo bước. File thuần (KHÔNG import antd) để test được dưới jest.
import type { JobStepProgress } from '../../../types/adaptationWorkbench';

/** `"<label> (i/N)"`; thiếu số hoặc total = 0 ⇒ `"<label>"`. `current > total` ⇒ kẹp. Không có tiến độ ⇒ chuỗi rỗng. */
export const formatJobStepProgress = (p: JobStepProgress | null | undefined): string => {
  if (!p || typeof p.label !== 'string' || !p.label.trim()) return '';
  const { current, total } = p;
  // 261015 P4c-1: bước EXTRACT của tổng quan có nhãn BE đã mang phân số ("Đọc quyển 2/3") ⇒ không nối thêm "(2/3)". Chỉ riêng bước này (và REVIEW của cổng chuỗi 3d1, READ «Đọc cả mùa — lô k/M» của 3e) — các nhãn khác (vd "vòng 1/2") giữ hành vi cũ.
  const labelHasFraction = (p.step === 'EXTRACT' || p.step === 'REVIEW' || p.step === 'READ') && /\d+\s*\/\s*\d+/.test(p.label);   // 261025 3d1: nhãn cổng chuỗi «Sửa vòng 1/2…» đã mang phân số
  if (typeof current === 'number' && typeof total === 'number' && total > 0 && !labelHasFraction) {
    return `${p.label} (${Math.max(0, Math.min(current, total))}/${total})`;
  }
  return p.label;
};
